import React, { Component, Suspense } from 'react';
import { Router } from 'react-router-dom';
import { history } from '../history';
import styled from 'styled-components';
import { store } from '../stores/mainStore';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { debounce } from 'lodash';
import { User } from '../stores/models/User';
import { PhaserGame } from './PhaserGame';
import { AnimatePresence } from 'framer-motion';
import { Spinner } from '../elements/Elements';
import {integration} from '../integration';
import {i18n} from '../i18n';
import {B64Image, preloadImages} from './B64Image';
import {comm} from '../comm';
import {ConnectionError, ServerError} from './SkillzPopups';
const RoutesLazy = React.lazy(() => import('./RoutesLazy'));

window.router = history;

window.gameTimeouts = [];
window.gameSetTimeout = function (f, delay, ...rest) {
	const id = setTimeout(f, delay, ...rest);
	window.gameTimeouts.push(id);
	return id;
};

const AppBody = styled.div`
	height: 100vh;
	width: 100vw;
	background: url(${p => p.imgCss.watermark}) center/contain no-repeat, 
		url(${p => p.imgCss.bkg}) center/cover, 
		${ 'linear-gradient(0deg, rgba(63, 87, 177, 1) 0%, rgba(49, 108, 205, 1) 100%)'},
		#3f57b1;

	--bar-height: ${store.topBar.heightWide};
	@media (max-aspect-ratio: ${store.topBar.wtRatio}) {
		--bar-height: ${store.topBar.heightTall};
	}
	--tb-icon-height: calc(0.8 * var(--bar-height));
`;

const Debug = styled.div`
	min-height: 2em;
	max-height: 400px;
	box-sizing: border-box;
	overflow: auto;
	background-color: rgba(255, 255, 255, 0.75);
	opacity: 0.75;
	text-shadow: none;
	color: black;
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100vw;
	pointer-events: none;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	z-index: 1000000;
	padding: 0.5em 1em;
	& > div {
		padding: 2px;
		&:nth-child(even) {
			color: red;
		}
	}
`;

@observer
export class Main extends Component {
	@observable windowSizeStable = false;
	@observable loading = true;
	@observable bkgLoading = true;
	@observable online = true;
	@observable restartWhenOnline = false;
	imgForCSS = null;

	constructor(props) {
		super(props);
		var bootCount = parseFloat(localStorage.getItem('bootCount')) + 1 || 1;
		window.setPersistentStorage('bootCount', bootCount);
		integration.postEvent(bootCount === 1 ? 'visit_new' : 'visit_repeat', 'user')
		integration.postMixPanelEvent(bootCount === 1 ? 'launch_first' : 'launch_repeat');
		const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
		store.isMobile = regex.test(navigator.userAgent)
		integration.postEvent(store.isMobile ? 'visit_device' : 'visit_browser', 'user', navigator.userAgent)

		store.showTutorial = comm.r7Data.ftue === 'True';

		Promise.all([
			preloadImages([
				'assets/skin/watermark.png', 
				'assets/skin/gameBkg.jpg'
			]).then(res => {
				const [watermark, bkg] = res;
				this.imgForCSS = {watermark, bkg};
				this.bkgLoading = false;
			}),
			comm.Login(),
			LandscapeMessage.preloadImages(),
			ConnectionError.preloadImages(),
			ServerError.preloadImages(),
			Spinner.preloadImages(),
		]).then(() => {	
			this.loading = false;
			/* if(store.showTutorial && localStorage.getItem('rules_viewed') !== 'true') {
				store.showSkillzRules = 1;		
			} else {
				window.manager.launchGameTable(Date.now());
			} */
		});

		//push location into the memory history
		// remove 'index.html' from Redirect flow
		history.push(window.location.pathname.replace(/index.html/g, ''));

		store.user = new User(store);
		// instead of login flow
		store.user.isReady = true;
		store.loginComplete = true;
		store.currentTosId = 1;
		
		window.addEventListener('message', evt => {
			if(typeof evt.data !== 'string')		return
			const data = JSON.parse(evt.data);
			if(!data || !data.event)				return
			switch(data.event) {
				case "update_balance" :
					console.log('R7 event update_balance', data.state);
					if(data.state) 
						store.updateBalance(true)
					break;				
				case "bet_unlock" :
					console.log('9245 R7 event bet_unlock', data.state, 'cur bets =', store.stakes.join(','));
					if(data.state) {
						store.getMe().then(({betAmounts}) => {
							store.stakes = betAmounts.map(v => v.stake)
							console.log('9245 R7 after bet_unlock cur bets =', store.stakes.join(','));
							//store.bet = betAmounts.find(v => v.isDefault === true).stake || store.bet;
						})
					}
					break;				
				case "update_autoroll" :
					console.log('R7 event update_autoroll', data.state);
					if(!data.state)
						store.isAutoroll = false;
					break;
				default :
					console.log('R7 Unknown event', data.event)
			}
		}, false);

		window.addEventListener('resize', this.waitForSize);
		this.waitForSize();
		window.addEventListener('online', () => {
			this.online = true;
			store.forceRemoveSpinner();
			if (this.restartWhenOnline) {
				window.restartWebview();
			}
		});
		window.addEventListener('offline', () => {
			this.online = false;
			store.forceRemoveSpinner();
		});

		
		window.addEventListener('blur', () => {
			integration.postMixPanelEvent('app_pause');
		});
		window.addEventListener('focus', () => {
			integration.postMixPanelEvent('app_pause_resume');
		});
	}

	waitForSize = debounce(() => {
		if (window.innerHeight > 300 && window.innerWidth > 300) {
			this.windowSizeStable = true;
			store.recalcAspectRatio();
		} else {
			this.waitForSize();
		}
	}, 2500);

	render() {
		return <Router history={history}>
			{!this.bkgLoading && <AppBody className={store.aspectName} imgCss={this.imgForCSS}>
				{!this.loading && <>
					<Suspense fallback={<div></div>}>
						<RoutesLazy/>
					</Suspense>
					{this.windowSizeStable && <PhaserWrapper key="phaserWrap"
						display={store.activeMatch ? 'block' : 'none'}
					>
						<PhaserGame key={`phaser-${store.phaserInstanceIndex}`} />
					</PhaserWrapper>}

					{store.debug !== '' && <Debug>{`${store.debug}`}</Debug>}

					{!this.online && <ConnectionError
						onClick={() => {
							window.manager.playAudio('poopPop');
							this.restartWhenOnline = true;
						}}
					/>}
					{this.online && <AnimatePresence>
						{store.spinner && <Spinner />}
					</AnimatePresence>}

					{!!store.errorMessage && <ServerError/>}
					{store.aspectIs('Landscape') && <LandscapeMessage/>}
				</>}
			</AppBody>}
			</Router>
	}
}
const PhaserWrapper = styled.div`
	display: ${p => p.display};
	position: absolute;
	height: 100%;	width: 100%;
	top: 0;			left: 0;
`;
const LandscapeMessage = styled(p => { return (
	<div className={p.className}>
		<B64Image src='assets/rotate_device_phone_black.png'/>
		<div>
			<p>{i18n.t('landscape_1')}</p>
			<p>{i18n.t('landscape_2')}</p>
		</div>
	</div>
)})`
	width: 100vw;		height: 100vh;
	position: absolute;    z-index: 5000;
    top: 0;    left: 0;
	background-color: #000000;
	display: flex;		gap: 5vw;
	align-items: center;
	img {	height: min(35vw, 60vh); }
	color: white;
	font-size: 5vw;
    padding: 0 2vw;
	p { margin-block: 0.5em;}
`;
LandscapeMessage.preloadImages = () => preloadImages(['assets/rotate_device_phone_black.png']);
